import React from 'react'

import noop from 'lib/function/noop'
import { CuratedBaseItemSelection } from 'tripPlanner/components/CuratedItemSelection/CuratedBaseItemSelection'
import { useAirport } from 'tripPlanner/hooks/api/flights'
import { FlightItem } from 'tripPlanner/types/tripItem'

interface Props {
  item: FlightItem
  onSelect: () => void
  isSelected: boolean
}
export function CuratedFlightItemSelection({
  item,
  onSelect,
  isSelected,
}: Props) {
  const { data: arrivalAirport } = useAirport({
    code: item.destinationAirportCode,
    onSuccess: noop,
    onError: noop,
  })

  const { data: departureAirport } = useAirport({
    code: item.originAirportCode,
    onSuccess: noop,
    onError: noop,
  })
  const departureAirportName =
    departureAirport?.cityAirportName ||
    departureAirport?.cityDesc ||
    item.startPlace.name

  const arrivalAirportName =
    arrivalAirport?.cityAirportName ||
    arrivalAirport?.cityDesc ||
    item.endPlace.name

  const hasAirports = !!(departureAirport && arrivalAirport)

  return (
    <CuratedBaseItemSelection
      type={item.type}
      title={
        hasAirports ?
          `${departureAirportName} to ${arrivalAirportName}` :
          item.airlineName
      }
      onSelect={onSelect}
      isSelected={isSelected}
    />
  )
}
